import { Entry } from "../App";
import { TestView } from "../tests/test";
import ProvinceList from "../views/pages/generic/ProvinceList";
import { Login } from "../views/pages/Login";
import { Register } from "../views/pages/Register";
import Accounts from "../views/pages/tabs/Accounts";
import Attractions from "../views/pages/tabs/Attractions";
import { Forms } from "../views/pages/tabs/Forms";
import { Overnight } from "../views/pages/tabs/forms/overnight";
import { SameDay } from "../views/pages/tabs/forms/sameday";
import SameDayDashboard from "../views/pages/tabs/dashboard/Sameday";
import SameDayLGU from "../views/pages/tabs/forms/sameday/LGU";
import SameDayReport from "../views/pages/tabs/forms/sameday/Report";
import SameDayStatus from "../views/pages/tabs/forms/sameday/Status";
import { SameDayReports } from "../views/pages/tabs/reports/Sameday";
import SameDayLGUSubmissions from "../views/pages/tabs/submissions/sameday/LGU";
import SameDayProvinceSubmissions from "../views/pages/tabs/submissions/sameday/Province";
import { MainRouter } from "./router";

export const ALL_ROUTES = {
    "/": Entry,
    "/login": Login,
    "/register": Register,
    "/forms": {
        roles: [ "admin", "province", "lgu", "reviewer" ],
        view: Forms
    },
    "/forms/sameday": {
        roles: [ "admin", "province", "lgu", "reviewer" ],
        view: SameDay
    },
    "/forms/overnight": {
        roles: [ "admin", "province", "lgu", "reviewer" ],
        view: Overnight
    },

    "/forms/sameday/all/:level": {
        roles: [ "admin", "reviewer", "province", "lgu" ],
        view: SameDayStatus,
        args: { tab: "all" },
    },

    "/forms/sameday/pending": {
        roles: [ "admin", "reviewer", "province" ],
        view: SameDayStatus,
        args: { tab: "pending" },
    },

    "/forms/sameday/returned": {
        roles: [ "province", "lgu" ],
        view: SameDayStatus,
        args: { tab: "returned" },
    },

    "/forms/sameday/published": {
        roles: [ "admin", "reviewer", "province", "lgu" ],
        view: SameDayStatus,
        args: { tab: "published" },
    },


    "/forms/sameday/report/draft": {
        roles: [ "lgu" ],
        view: SameDayReport,
        args: { isDraft: true }
    },

    "/forms/sameday/report/:id": {
        roles: [ "admin", "reviewer", "province", "lgu" ],
        view: SameDayReport,
        args: { isDraft: false }
    },


    "/dashboard/sameday": {
        view: SameDayDashboard
    },





    "/forms/sameday/lgu/:lguid/draft/:month/:year": {
        roles: [ "admin", "province", "lgu" ],
        view: SameDayLGU,
        args: { type: "draft" }
    },
    "/forms/sameday/lgu/:lguid/submissions/:month/:year": {
        roles: [ "admin", "province", "lgu", "reviewer" ],
        view: SameDayLGUSubmissions
    },
    "/forms/sameday/province/:provinceid/submissions/:month/:year": {
        roles: [ "admin", "province", "reviewer" ],
        view: SameDayProvinceSubmissions
    },
    "/forms/sameday/provinces": {
        roles: [ "admin", "reviewer" ],
        view: ProvinceList,
        args: { 
            title: "Sameday Visit Submissions", 
            itemRedirect: ({ province, month, year }) => 
                MainRouter.goto(`/forms/sameday/province/${province}/submissions/${month}/${year}`) }
    },
    "/forms/sameday/lgu/:lguid/submissions/:submissionid": {
        roles: [ "admin", "province", "lgu", "reviewer" ],
        view: SameDayLGU,
        args: { type: "submission" }
    },
    "/accounts": {
        roles: [ "admin" ],
        view: Accounts
    },
    "/attractions": {
        roles: [ "admin" ],
        view: Attractions
    },
    "/reports/sameday": {
        roles: [ "admin", "province", "lgu", "reviewer" ],
        view: SameDayReports
    },
    "/test": TestView,
    "*": NotFound
};



function NotFound() {
    return (<div>Page not found</div>);
}
